import type { ComponentIR } from "../ir.js";
import type { GeneratedFile, GenerateOptions, Generator } from "./types.js";
import { operationTypeNames } from "./schema-to-ts.js";

function countAgenticOperations(ir: ComponentIR): number {
  return Object.values(ir.operations).filter((op) => !op.handler).length;
}

export const clientGenerator: Generator = {
  generate(ir: ComponentIR, _options: GenerateOptions): GeneratedFile[] {
    const agenticOpsCount = countAgenticOperations(ir);

    const functions = Object.keys(ir.operations).map((operationName) => {
      const names = operationTypeNames(operationName);
      return `export async function ${operationName}(
  options: ${names.options},
  input: ${names.input},
  ctx: AaacInvocationContext,
  memoryRef?: string,
): Promise<${names.output}> {
  return runtime.execute(${JSON.stringify(operationName)}, options, input, ctx, memoryRef) as Promise<${names.output}>;
}`;
    });

    if (agenticOpsCount >= 2) {
      functions.push(`export async function prompt(
  options: PromptExecuteOptions,
  input: { message: string },
  ctx: AaacInvocationContext,
): Promise<PromptResult> {
  return runtime.executePrompt(input.message, options as unknown as Record<string, unknown>, ctx) as Promise<PromptResult>;
}`);
    }

    const runtimeTypeImports =
      agenticOpsCount >= 2
        ? `import type { PromptResult, PromptExecuteOptions } from "@aaac/runtime";
`
        : "";

    const content = `/** Auto-generated by @aaac/contracts. Do not edit. */
/* eslint-disable */

import type {
${Object.keys(ir.operations)
  .flatMap((name) => {
    const n = operationTypeNames(name);
    const types = [n.input, n.output, n.options];
    return types.map((t) => `  ${t},`);
  })
  .join("\n")}
} from "./component.types.js";
${runtimeTypeImports}import { runtime, type AaacInvocationContext } from "./component.runtime.js";

${functions.join("\n\n")}
`;

    return [
      {
        path: "component.client.ts",
        content,
        overwrite: true,
      },
    ];
  },
};
